import React from "react"
import Landingpage from "../../images/it-landing-page.jpg"
import classes from "./home.module.scss"
import { Element } from "react-scroll"

const home = () => {
  return (
    <Element name="home">
      <section>
        <div className={classes.imgContainer}>
          <img src={Landingpage} alt="" />
          <div className={classes.imgText}>
            <p className={classes.subtitles}>Inovaciniai IT sprendimai</p>
          </div>
        </div>
      </section>
    </Element>
  )
}

export default home
